import React from 'react';
import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const faqs = [
  {
    question: 'Is this a real wedding?',
    answer: 'No, this is a staged cultural experience. There is no real couple getting married. It\'s a professionally organized event designed to give you the complete Kerala wedding experience without any actual marriage ceremony.'
  },
  {
    question: 'What should I wear?',
    answer: 'We recommend Kerala festive attire — kasavu saree, mundu, or any smart ethnic wear. Feel free to dress up and be part of the authentic experience! Traditional attire is encouraged but not mandatory.'
  },
  {
    question: 'Can I bring kids?',
    answer: 'Absolutely! Children under 5 years old get free entry. Kids between 5-12 years get a 50% discount. It\'s a family-friendly experience with activities suitable for all ages.'
  },
  {
    question: 'Is the food vegetarian?',
    answer: 'Traditional Kerala Sadya is completely vegetarian and served on banana leaves. Some events may feature separate non-vegetarian live counters. Dietary preferences can be indicated during booking.'
  },
  {
    question: 'What\'s the refund policy?',
    answer: 'Full refund if cancelled 7+ days before the event. 50% refund for cancellations made 3-7 days before. No refund for cancellations within 48 hours of the event. In case of event cancellation from our side, full refund will be processed.'
  },
  {
    question: 'How long does the event last?',
    answer: 'The complete experience typically lasts 4-5 hours, including all rituals, feast, entertainment, and photo sessions. Exact timings will be shared in your confirmation email.'
  },
  {
    question: 'Can I take photos and videos?',
    answer: 'Yes! Photography and videography for personal use are allowed. We also have professional photographers capturing the event, and you can purchase high-resolution photos separately.'
  },
  {
    question: 'Is parking available?',
    answer: 'Yes, complimentary parking is available for all ticket holders. Premium and VIP ticket holders get reserved parking spots closer to the venue.'
  }
];

const FAQSection = () => {
  return (
    <section className="py-24 md:py-32 px-6 bg-stone-50" data-testid="faq-section">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-normal text-emerald-900 mb-4" data-testid="faq-title">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-stone-600" data-testid="faq-subtitle">
            Everything you need to know before booking
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`} 
                className="glass-card px-6 rounded-2xl border-0"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left text-lg font-medium text-emerald-900 hover:text-yellow-600 py-6 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-stone-700 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;